// Copyright (c) 2019 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../shared/action-creators/get-claim-types';
import actions from '../../action-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_CLAIM_WEAR_PARTS_CLAIM_TYPES);



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/get-claim-types.js